import React from 'react';
import { connect } from 'react-redux';
import Mixpanel from 'helpers/Mixpanel.js';
import { Page, PageBody } from '@bit/knotchinc.web-react-components.page';
import { ComponentTabContainer, ComponentTab } from '@bit/knotchinc.web-react-components.tabs';
import PageHeader from 'components/Global/PageHeader/PageHeader.jsx';
import StoreSync from '@bit/knotchinc.web-react-components.store-sync';
import { fetchReportData } from '../actions.js';
import { ContentReportTab, BrandsReportTab, SocialReportTab, KeywordsReportTab, PublishersReportTab, ReportErrorTab } from './tabs';

export class ReportWebView extends React.Component {
  componentDidMount() {
    const { match, getData } = this.props;

    getData(match.params.reportId);
    Mixpanel.track('viewed Report', { report_id: match.params.reportId });
  }

  componentDidUpdate({ match: oldMatch }) {
    const { params: { reportId: oldReportId } } = oldMatch;
    const { match, getData } = this.props;

    if (match.params.reportId !== oldReportId) {
      getData(match.params.reportId);
    }
  }

  render() {
    const { report, isKnotchAdmin } = this.props;
    const { data = {}, fetched } = report;
    const { request = {} } = data;

    if (report.status && report.status === 'error') {
      return (
        <Page>
          <PageHeader title={'Report Error'} />
          <PageBody>
            <ComponentTabContainer>
              <ComponentTab tabName="Whoops!">
                <ReportErrorTab error={{ type: 'error' }} />
              </ComponentTab>
            </ComponentTabContainer>
          </PageBody>
        </Page>
      );
    }
    let subtitle = null;

    if (isKnotchAdmin && fetched) {
      subtitle = `${request.account_name} - ${request.user_email}`;
    }

    return (
      <Page>
        <PageHeader
          title={`Report ${request.title || ''}`}
          subtitle={subtitle}
        />
        <PageBody>
          <ComponentTabContainer>
            <ComponentTab tabName="Content Report">
              <StoreSync stores={{ report }}>
                <ContentReportTab />
              </StoreSync>
            </ComponentTab>
            { isKnotchAdmin ? (
              <ComponentTab tabName="Social Performance Report">
                <StoreSync stores={{ report }}>
                  <SocialReportTab />
                </StoreSync>
              </ComponentTab>
            ) : null}
            <ComponentTab tabName="Keywords Report">
              <StoreSync stores={{ report }}>
                <KeywordsReportTab />
              </StoreSync>
            </ComponentTab>
            { request.report_type === 'brand' ? (
              <ComponentTab tabName="Publishers Report">
                <StoreSync stores={{ report }}>
                  <PublishersReportTab />
                </StoreSync>
              </ComponentTab>
            ) : null }
            { request.report_type === 'publisher' ? (
              <ComponentTab tabName="Brands Report">
                <StoreSync stores={{ report }}>
                  <BrandsReportTab />
                </StoreSync>
              </ComponentTab>
              ) : null }
          </ComponentTabContainer>
        </PageBody>
      </Page>
    );
  }
}

const mapStateToProps = ({
  Reports: { report }, Account: { isKnotchAdmin },
}) => ({ report, isKnotchAdmin });

const mapDispatchToProps = dispatch => ({
  getData: id => dispatch(fetchReportData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportWebView);
